export default "__VITE_ASSET__xJo9akig__"